import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AddUserButtonIcon } from '../../assets';
import { PERMISSIONS } from '../../config/constants';
import { usePermissions } from '../../hooks/usePermissions';
import { Button } from '../common/Button';
import { InfluencerPopUp } from './InfluencerPopUp';

export const CreateInfluencer = ({ refetch }: { refetch: any }) => {
  const { t } = useTranslation('common');
  const [open, setOpen] = useState(false);
  const { checkPermission } = usePermissions();

  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        style="light-blue"
        text={t('influencers.createInfluencer')}
        id="createInfluencer"
        iconLeft={<AddUserButtonIcon />}
        customClassnames={`${!checkPermission(PERMISSIONS.CREATE_INFLUENCER) && 'hidden'}`}
      />
      {open && <InfluencerPopUp setOpen={setOpen} refetch={refetch} />}
    </>
  );
};
